module.exports = __webpack_public_path__ + "img/mobile_screen.f064195e.png";